<template>
  <v-row class="align-center justify-center fill-height">
    <v-col class="flex-shrink-1 flex-grow-0">
      <v-img src="/images/sh-logo-light.png" style="width: 230px; max-width: 230px;" class="mx-auto mb-6" contain />
      <transition name="fade-up" mode="out-in" appear>
        <router-view></router-view>
      </transition>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'Auth',

  data: () => ({
  })
};
</script>
